import { memo, useCallback } from 'react';

import CustomCheckbox from '@/components/Checkbox';
import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { toggleSymbol } from '@/slices/symbolSelectorSlice';
import { SelectedSymbol } from '@/types/symbols';
import { isSameSymbol, isSameSymbolIgnoringPeriod } from '@/utils/isSameSymbol';

const SymbolCheckboxComponent = ({
  symbol,
  disabled
}: {
  symbol: SelectedSymbol;
  disabled?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const isForwardMode = useAppSelector(state => state.symbolSelector.isForwardMode);

  // Subscribe to just the boolean selected state for this specific symbol.
  const isChecked = useAppSelector(state => {
    const equals = isForwardMode ? isSameSymbolIgnoringPeriod : isSameSymbol;
    return state.symbolSelector.symbols.some(s => equals(s, symbol));
  });

  const handleChange = useCallback(() => {
    dispatch(toggleSymbol({ symbol }));
  }, [dispatch, symbol]);

  return (
    <CustomCheckbox
      checked={isChecked}
      disabled={disabled}
      onChange={handleChange}
    />
  );
};

export const SymbolCheckbox = memo(SymbolCheckboxComponent);
